var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.final_percentage > 0)?_c('div',{staticClass:"sale-ribbon"},[_vm._v(" -"+_vm._s(_vm.final_percentage)+"% ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }